import { captureException } from '@atlassian/error-handling';

const getMeta = (name: string): string | undefined => {
	if (typeof document === 'undefined') {
		return undefined;
	}
	const element = document.querySelector(`meta[name="${name}"]`);
	return element?.getAttribute('content') ?? undefined;
};

const extractFirstName = (fullName: string | undefined): string | undefined => {
	if (!fullName?.trim()) {
		return undefined;
	}
	const firstName = fullName.trim().split(' ')[0];
	return firstName || undefined;
};

export const fetchUserName = async (): Promise<string | undefined> => {
	let userData;

	try {
		const response = await fetch('/gateway/api/me');
		if (response.ok) {
			userData = await response.json();
		}
	} catch (error) {
		captureException('Failed to fetch user name from API', error as Error, {
			packageName: '@atlassian/twc-xflow-modal',
			teamName: 'starburst',
		});
	}

	const firstName =
		extractFirstName(userData?.nickname) ||
		extractFirstName(userData?.name) ||
		extractFirstName(getMeta('ajs-remote-user-fullname'));

	return firstName;
};
